import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image, Link } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 24,
    fontSize: 7.5,
    fontFamily: 'Helvetica',
    color: '#000000',
    backgroundColor: '#ffffff',
  },

  // --- HEADER SUPERIOR (IMAGEN 1) ---
  topHeaderTable: {
    flexDirection: 'row',
    borderWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    marginBottom: 6,
    minHeight: 52,
  },
  headerLogoCol: {
    width: '18%',
    borderRightWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 3,
  },
  headerLogo: {
    maxHeight: 46,
    maxWidth: '92%',
    objectFit: 'contain',
  },
  headerCenterCol: {
    width: '62%',
    borderRightWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 6,
    paddingVertical: 2,
  },
  companyName: {
    fontSize: 12,
    fontFamily: 'Helvetica-Bold',
    color: '#1e3a8a',
    textAlign: 'center',
    marginBottom: 2,
  },
  companyContact: {
    fontSize: 6.8,
    fontFamily: 'Helvetica-Bold',
    color: '#000000',
    textAlign: 'center',
    marginBottom: 2,
  },
  companyWebsite: {
    fontSize: 7.5,
    fontFamily: 'Helvetica-Bold',
    color: '#1e3a8a',
    textAlign: 'center',
    textDecoration: 'underline',
  },
  headerRightCol: {
    width: '20%',
    flexDirection: 'column',
  },
  metaItemRow: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    paddingHorizontal: 2,
    paddingVertical: 2,
  },
  metaRowText: {
    fontSize: 6.8,
    textAlign: 'center',
    fontFamily: 'Helvetica',
  },

  // --- TABLA REPORTE DE MANTENIMIENTO METADATA ---
  metaTable: {
    borderWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    marginBottom: 6,
  },
  metaTitleBar: {
    backgroundColor: '#ffffff',
    borderBottomWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    paddingVertical: 2.5,
    alignItems: 'center',
  },
  metaTitleText: {
    fontSize: 8.5,
    fontFamily: 'Helvetica-Bold',
    textAlign: 'center',
    letterSpacing: 0.5,
  },
  metaRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    minHeight: 15,
    alignItems: 'center',
  },
  metaCell: {
    paddingHorizontal: 4,
    paddingVertical: 2,
    fontSize: 7,
  },
  bold: {
    fontFamily: 'Helvetica-Bold',
  },

  // --- PREGUNTAS EN 2 COLUMNAS (B, R, M, NA) ---
  twoColWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    marginBottom: 6,
  },
  colHalf: {
    width: '49.4%',
    flexDirection: 'column',
  },
  groupBlock: {
    borderWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    marginBottom: 6,
  },
  groupHeaderRow: {
    flexDirection: 'row',
    backgroundColor: '#94a3b8',
    borderBottomWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    paddingVertical: 2,
    alignItems: 'center',
  },
  groupTitleText: {
    width: '72%',
    paddingLeft: 4,
    fontFamily: 'Helvetica-Bold',
    fontSize: 7.5,
    color: '#000000',
    textAlign: 'center',
  },
  groupResponseHead: {
    width: '28%',
    textAlign: 'center',
    fontFamily: 'Helvetica-Bold',
    fontSize: 7,
    borderLeftWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    color: '#000000',
  },
  questionRow: {
    flexDirection: 'row',
    borderBottomWidth: 0.5,
    borderColor: '#000000',
    borderStyle: 'solid',
    minHeight: 14,
    alignItems: 'stretch',
  },
  qTextCol: {
    width: '72%',
    paddingHorizontal: 4,
    paddingVertical: 2,
    justifyContent: 'center',
  },
  qTitle: {
    fontSize: 6.8,
    fontFamily: 'Helvetica',
    color: '#000000',
  },
  qCustomOptionText: {
    fontSize: 6.2,
    fontFamily: 'Helvetica-Oblique',
    color: '#0f172a',
    marginTop: 1.5,
  },
  qObsText: {
    fontSize: 6,
    fontFamily: 'Helvetica-Oblique',
    color: '#334155',
    marginTop: 1.5,
  },
  qPhotosContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 2,
  },
  qThumbLink: {
    marginRight: 4,
    marginBottom: 4,
    textDecoration: 'none',
  },
  qThumb: {
    width: 44,
    height: 44,
    borderWidth: 0.5,
    borderColor: '#94a3b8',
    borderStyle: 'solid',
    objectFit: 'cover',
  },
  qThumbSingle: {
    width: 65,
    height: 60,
    borderWidth: 0.5,
    borderColor: '#94a3b8',
    borderStyle: 'solid',
    objectFit: 'cover',
  },
  qThumbPhotoOnly: {
    width: 52,
    height: 50,
    borderWidth: 0.5,
    borderColor: '#94a3b8',
    borderStyle: 'solid',
    objectFit: 'cover',
  },
  qThumbPhotoOnlySingle: {
    width: 90,
    height: 80,
    borderWidth: 0.5,
    borderColor: '#94a3b8',
    borderStyle: 'solid',
    objectFit: 'cover',
  },
  qResponseCol: {
    width: '28%',
    borderLeftWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 2,
  },
  responseBadge: {
    paddingVertical: 2,
    paddingHorizontal: 4,
    borderRadius: 3,
    borderWidth: 0.5,
    maxWidth: '96%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  responseText: {
    fontSize: 6.8,
    fontFamily: 'Helvetica-Bold',
    textAlign: 'center',
  },

  // --- RESUMEN DE LA INSPECCIÓN ---
  summaryBox: {
    borderWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    marginBottom: 6,
  },
  summaryHeaderBar: {
    backgroundColor: '#1e3a8a',
    paddingVertical: 3,
    alignItems: 'center',
  },
  summaryHeaderTitle: {
    color: '#ffffff',
    fontFamily: 'Helvetica-Bold',
    fontSize: 8.5,
    textAlign: 'center',
    letterSpacing: 0.5,
  },
  summaryRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    paddingVertical: 2,
    paddingHorizontal: 6,
  },
  summaryLabel: {
    width: '75%',
    fontSize: 7.5,
    fontFamily: 'Helvetica-Bold',
  },
  summaryVal: {
    width: '25%',
    fontSize: 7.5,
    fontFamily: 'Helvetica-Bold',
    textAlign: 'center',
  },

  // --- REPUESTOS / TRABAJOS RECOMENDADOS & ACTIVIDADES ---
  recomBox: {
    borderWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    marginBottom: 6,
  },
  recomHeaderBar: {
    backgroundColor: '#1e3a8a',
    paddingVertical: 3,
    alignItems: 'center',
  },
  recomHeaderTitle: {
    color: '#ffffff',
    fontFamily: 'Helvetica-Bold',
    fontSize: 8.5,
    textAlign: 'center',
    letterSpacing: 0.5,
  },
  recomRowHeader: {
    flexDirection: 'row',
    backgroundColor: '#f1f5f9',
    borderBottomWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    paddingVertical: 2,
  },
  recomRow: {
    flexDirection: 'row',
    borderBottomWidth: 0.5,
    borderColor: '#000000',
    borderStyle: 'solid',
    minHeight: 14,
    alignItems: 'center',
  },
  recomColNum: {
    width: '6%',
    textAlign: 'center',
    fontSize: 7,
    fontFamily: 'Helvetica-Bold',
    borderRightWidth: 0.5,
    borderColor: '#000000',
    borderStyle: 'solid',
    paddingVertical: 1,
  },
  recomColDesc: {
    width: '44%',
    fontSize: 7,
    paddingHorizontal: 4,
    borderRightWidth: 0.5,
    borderColor: '#000000',
    borderStyle: 'solid',
    paddingVertical: 1,
  },
  recomColQty: {
    width: '10%',
    textAlign: 'center',
    fontSize: 7,
    borderRightWidth: 0.5,
    borderColor: '#000000',
    borderStyle: 'solid',
    paddingVertical: 1,
  },
  recomColPrio: {
    width: '15%',
    textAlign: 'center',
    fontSize: 7,
    borderRightWidth: 0.5,
    borderColor: '#000000',
    borderStyle: 'solid',
    paddingVertical: 1,
  },
  recomColObs: {
    width: '25%',
    fontSize: 7,
    paddingHorizontal: 4,
    paddingVertical: 1,
  },

  // --- OBSERVACIONES Y 3 FIRMAS ---
  obsSection: {
    borderWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    marginBottom: 6,
  },
  obsHeaderBar: {
    backgroundColor: '#1e3a8a',
    borderBottomWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    paddingVertical: 2.5,
    alignItems: 'center',
  },
  obsHeaderTitle: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 8,
    color: '#ffffff',
    textAlign: 'center',
  },
  obsBody: {
    padding: 6,
    minHeight: 40,
  },
  obsBodyText: {
    fontSize: 7,
    fontFamily: 'Helvetica',
    color: '#000000',
  },
  legendBar: {
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    paddingVertical: 2,
    paddingHorizontal: 4,
    backgroundColor: '#ffffff',
  },
  legendText: {
    fontSize: 7,
    fontFamily: 'Helvetica-Bold',
  },
  signaturesTable: {
    flexDirection: 'row',
  },
  signatureCol3: {
    width: '33.33%',
    borderRightWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
  },
  sigHeaderCell: {
    borderBottomWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    paddingVertical: 2.5,
    textAlign: 'center',
    fontFamily: 'Helvetica-Bold',
    fontSize: 7.2,
    backgroundColor: '#f8fafc',
  },
  sigImgBox: {
    height: 48,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 3,
    borderBottomWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
  },
  sigImg: {
    maxHeight: 42,
    maxWidth: 120,
    objectFit: 'contain',
  },
  sigMetaCell: {
    borderBottomWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    paddingVertical: 2,
    paddingHorizontal: 4,
    fontSize: 6.8,
  },
  pendingDeliveryBadge: {
    fontSize: 6.5,
    fontFamily: 'Helvetica-Oblique',
    color: '#94a3b8',
    textAlign: 'center',
  },

  // --- FORMATO DE EMERGENCIA ---
  emergencyContainer: {
    borderWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    marginTop: 4,
    marginBottom: 6,
  },
  emergencyBoxSection: {
    borderBottomWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    padding: 6,
    minHeight: 115,
  },
  emergencySectionTitle: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 8.5,
    color: '#000000',
    marginBottom: 4,
  },
  emergencyContentText: {
    fontFamily: 'Helvetica',
    fontSize: 7.5,
    color: '#000000',
    lineHeight: 1.35,
  },
  emergencyPhotosRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 6,
  },
  emergencyThumbLink: {
    marginRight: 4,
    marginBottom: 4,
    textDecoration: 'none',
  },
  emergencyThumb: {
    width: 66,
    height: 66,
    borderWidth: 0.5,
    borderColor: '#94a3b8',
    borderStyle: 'solid',
    objectFit: 'cover',
  },
  emergencyThumbSingle: {
    width: 95,
    height: 85,
    borderWidth: 0.5,
    borderColor: '#94a3b8',
    borderStyle: 'solid',
    objectFit: 'cover',
  },
  emergencySubsanadaRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    height: 22,
    alignItems: 'stretch',
  },
  emergencySubsanadaLabelCell: {
    width: '40%',
    justifyContent: 'center',
    paddingLeft: 6,
    borderRightWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
  },
  emergencySubsanadaLabelText: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 8.5,
    color: '#000000',
  },
  emergencySubsanadaOptionCell: {
    width: '30%',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 8,
    borderRightWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
  },
  emergencyOptionText: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 8,
    color: '#000000',
    marginRight: 6,
  },
  emergencyCheckSquare: {
    width: 12,
    height: 12,
    borderWidth: 1,
    borderColor: '#000000',
    borderStyle: 'solid',
    justifyContent: 'center',
    alignItems: 'center',
  },
  emergencyCheckText: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 8,
    color: '#000000',
  },
});

export default function MaintenanceReportPdf({
  data,
  equipo,
  group,
  technicianName,
  deliveryTechnicianName,
  continuedByTechnicianName,
  customerName,
  customerEmail,
  maintenanceType,
  recommendations,
  activities,
  backendUrl,
}) {
  const getFullUrl = (path) => {
    if (!path) return null;
    if (typeof path === 'object' && path) path = path.preview || path.url || path.path;
    if (typeof path !== 'string') return null;
    if (path.startsWith('data:') || path.startsWith('blob:')) return path;
    const base = backendUrl ? (backendUrl.endsWith('/') ? backendUrl : backendUrl + '/') : '';
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;
    const token = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('Token') || '' : '';
    return token ? `${base}${cleanPath}?token=${encodeURIComponent(token)}` : `${base}${cleanPath}`;
  };

  const getPhotoLinkUrl = (path) => {
    if (!path) return null;
    let raw = path;
    if (typeof path === 'object' && path) {
      raw = path.originalUrl || path.url || path.path;
      if (!raw && path.preview && !path.preview.startsWith('data:')) {
        raw = path.preview;
      }
    }
    if (typeof raw !== 'string') return null;
    if (raw.includes('/api/v1/uploads/')) {
      raw = raw.replace('/api/v1/uploads/', '/uploads/');
    }
    if (raw.startsWith('http://') || raw.startsWith('https://')) return raw;
    if (raw.startsWith('/uploads') || raw.startsWith('uploads')) {
      const serverRoot = (backendUrl || '').replace(/\/api\/v1\/?$/, '');
      const clean = raw.startsWith('/') ? raw : `/${raw}`;
      return `${serverRoot}${clean}`;
    }
    return getFullUrl(raw);
  };

  const groupsList = group?.groups && group.groups.length > 0
    ? group.groups
    : (Array.isArray(group)
        ? group
        : [{ id: 1, name: 'Inspección General', questions: group?.questions || [] }]);

  const allQuestions = groupsList.flatMap((g) => g.questions || []);

  const getAnswerForQuestion = (qId) => {
    if (!data?.answers) return null;
    if (Array.isArray(data.answers)) {
      return data.answers.find((a) => String(a.question_id) === String(qId)) || null;
    }
    return data.answers[qId] || data.answers[String(qId)] || null;
  };

  // Determinar información completa de la respuesta (Texto, Color, Estado)
  const getQuestionAnswerInfo = (q, ans) => {
    const effectiveAns = ans || getAnswerForQuestion(q?.id);
    if (!effectiveAns) {
      return { label: 'Sin responder', status: 'NA', color: '#64748b', bg: '#f1f5f9', textColor: '#475569' };
    }

    // Asegurar opciones de la pregunta desde q, o buscar en allQuestions/group
    const questionWithOptions = (q?.options && q.options.length > 0)
      ? q
      : ((group?.questions || allQuestions || []).find((item) => String(item.id) === String(q?.id)) || q);
    const qOptions = questionWithOptions?.options || questionWithOptions?.AnswerOptions || questionWithOptions?.answer_options || [];

    const rawOpts = effectiveAns.optionIds || effectiveAns.selected_options || [];
    const optList = Array.isArray(rawOpts)
      ? rawOpts
      : (typeof rawOpts === 'string' && rawOpts.startsWith('[')
          ? (() => { try { return JSON.parse(rawOpts); } catch { return [rawOpts]; } })()
          : [rawOpts].filter(Boolean));
    const optIds = optList.map(String);

    const selectedOpts = qOptions.filter((o) =>
      optIds.includes(String(o.id)) ||
      optIds.includes(String(o.text).trim()) ||
      (effectiveAns.answer_text && String(o.text).trim().toLowerCase() === String(effectiveAns.answer_text).trim().toLowerCase()) ||
      (effectiveAns.text && String(o.text).trim().toLowerCase() === String(effectiveAns.text).trim().toLowerCase())
    );

    if (selectedOpts.length > 0) {
      const texts = selectedOpts.map((o) => o.text).filter(Boolean);
      const originalLabel = texts.join(', ') || 'Respondida';
      const primaryOpt = selectedOpts.find((o) => o.evaluation_type) || selectedOpts[0];
      const evalType = (primaryOpt.evaluation_type || '').toLowerCase().trim();
      let status = 'NA';
      if (evalType.includes('buen') || evalType === 'b' || evalType === 'bien' || evalType === 'conforme') status = 'B';
      else if (evalType.includes('regul') || evalType === 'r') status = 'R';
      else if (evalType.includes('mal') || evalType === 'm' || evalType.includes('defect') || evalType.includes('falla')) status = 'M';
      else if (evalType === 'na' || evalType === 'n/a' || evalType.includes('aplica')) status = 'NA';
      else if (primaryOpt.color === '#10b981' || primaryOpt.color === '#22c55e' || primaryOpt.color === '#16a34a' || primaryOpt.color === '#4caf50') status = 'B';
      else if (primaryOpt.color === '#f59e0b' || primaryOpt.color === '#d97706' || primaryOpt.color === '#ff9800') status = 'R';
      else if (primaryOpt.color === '#ef4444' || primaryOpt.color === '#dc2626' || primaryOpt.color === '#f44336') status = 'M';
      else {
        const lower = originalLabel.toLowerCase();
        if (lower.includes('buen') || lower === 'b' || lower.includes('correct') || lower.includes('bien')) status = 'B';
        else if (lower.includes('regul') || lower === 'r') status = 'R';
        else if (lower.includes('mal') || lower === 'm' || lower.includes('fall') || lower.includes('defect')) status = 'M';
        else status = 'B';
      }

      let color = primaryOpt.color;
      if (!color) {
        if (status === 'B') color = '#10b981';
        else if (status === 'R') color = '#f59e0b';
        else if (status === 'M') color = '#ef4444';
        else color = '#64748b';
      }

      // Comprobar si la opción seleccionada es diferente a las palabras "buena, regular, mala"
      const normText = originalLabel.trim().toLowerCase();
      const isStandardText =
        normText === 'bueno' || normText === 'buena' || normText === 'buenos' || normText === 'buenas' ||
        normText === 'regular' || normText === 'regulares' ||
        normText === 'malo' || normText === 'mala' || normText === 'malos' || normText === 'malas' ||
        normText === 'no aplica' || normText === 'na' || normText === 'n/a';

      let badgeLabel = originalLabel;
      let customOptionText = null;

      if (!isStandardText) {
        customOptionText = originalLabel;
        if (status === 'B') badgeLabel = 'Bueno';
        else if (status === 'R') badgeLabel = 'Regular';
        else if (status === 'M') badgeLabel = 'Malo';
        else badgeLabel = 'Bueno';
      } else {
        if (normText.includes('buen') || normText === 'b') badgeLabel = 'Bueno';
        else if (normText.includes('regul') || normText === 'r') badgeLabel = 'Regular';
        else if (normText.includes('mal') || normText === 'm') badgeLabel = 'Malo';
        else badgeLabel = 'NA';
      }

      return {
        label: badgeLabel,
        customOptionText,
        status,
        color,
        bg: `${color}18`,
        textColor: color === '#f59e0b' ? '#b45309' : color,
      };
    }

    // Fallback si la respuesta vino como texto libre o no coincidió por ID directo
    const textVal = (
      effectiveAns.answer_text ||
      effectiveAns.text ||
      effectiveAns.value ||
      effectiveAns.answer ||
      (optIds.length > 0 && isNaN(Number(optIds[0])) ? optIds.join(', ') : '')
    ).toString().trim();

    if (textVal) {
      const normText = textVal.toLowerCase();
      const matchingOpt = qOptions.find((o) =>
        String(o.text).trim().toLowerCase() === normText ||
        optIds.includes(String(o.id))
      );

      const isStandardText =
        normText === 'bueno' || normText === 'buena' || normText === 'buenos' || normText === 'buenas' ||
        normText === 'regular' || normText === 'regulares' ||
        normText === 'malo' || normText === 'mala' || normText === 'malos' || normText === 'malas' ||
        normText === 'no aplica' || normText === 'na' || normText === 'n/a';

      let status = 'NA';
      const optEval = matchingOpt?.evaluation_type ? String(matchingOpt.evaluation_type).toLowerCase().trim() : '';
      if (optEval.includes('buen') || optEval === 'b' || optEval === 'bien') status = 'B';
      else if (optEval.includes('regul') || optEval === 'r') status = 'R';
      else if (optEval.includes('mal') || optEval === 'm') status = 'M';
      else if (optEval === 'na' || optEval === 'n/a') status = 'NA';
      else if (matchingOpt?.color === '#10b981' || matchingOpt?.color === '#22c55e') status = 'B';
      else if (matchingOpt?.color === '#f59e0b' || matchingOpt?.color === '#d97706') status = 'R';
      else if (matchingOpt?.color === '#ef4444' || matchingOpt?.color === '#dc2626') status = 'M';
      else if (normText.includes('buen') || normText === 'b' || normText.includes('bien') || normText.includes('correct')) status = 'B';
      else if (normText.includes('regul') || normText === 'r') status = 'R';
      else if (normText.includes('mal') || normText === 'm' || normText.includes('fall') || normText.includes('defect')) status = 'M';
      else status = 'B';

      let color = matchingOpt?.color;
      if (!color) {
        if (status === 'B') color = '#10b981';
        else if (status === 'R') color = '#f59e0b';
        else if (status === 'M') color = '#ef4444';
        else color = '#64748b';
      }

      let badgeLabel = textVal;
      let customOptionText = null;

      if (!isStandardText) {
        customOptionText = matchingOpt?.text || textVal;
        if (status === 'B') badgeLabel = 'Bueno';
        else if (status === 'R') badgeLabel = 'Regular';
        else if (status === 'M') badgeLabel = 'Malo';
        else badgeLabel = 'Bueno';
      } else {
        if (normText.includes('buen') || normText === 'b') badgeLabel = 'Bueno';
        else if (normText.includes('regul') || normText === 'r') badgeLabel = 'Regular';
        else if (normText.includes('mal') || normText === 'm') badgeLabel = 'Malo';
        else badgeLabel = 'NA';
      }

      return {
        label: badgeLabel,
        customOptionText,
        status,
        color,
        bg: `${color}18`,
        textColor: color === '#f59e0b' ? '#b45309' : color,
      };
    }

    return { label: 'NA', status: 'NA', color: '#64748b', bg: '#f1f5f9', textColor: '#475569' };
  };

  const getQuestionStatus = (q, ans) => getQuestionAnswerInfo(q, ans).status;

  const isPhotoOnlyQuestion = (q) => {
    if (!q) return false;
    const type = (q.type || '').toLowerCase().trim();
    if (type === 'fotos' || type === 'foto' || type === 'imagenes' || type === 'imagen' || type === 'abierta') {
      return true;
    }
    if ((!q.options || q.options.length === 0) && type !== 'unica' && type !== 'multiple') {
      return true;
    }
    return false;
  };

  const PHOTO_SIZES = { full: { w: '100%', h: 100 }, half: { w: '100%', h: 70 } };
  const getPhotoThumbStyle = (count, isPhotoOnly) => {
    const s = isPhotoOnly ? PHOTO_SIZES.full : PHOTO_SIZES.half;
    return { width: s.w, height: s.h, borderWidth: 0.5, borderColor: '#94a3b8', borderStyle: 'solid', objectFit: 'cover' };
  };

  const getEmergencyThumbStyle = (count) => {
    if (count === 1) return styles.emergencyThumbSingle;
    if (count === 2) return { width: 80, height: 75, borderWidth: 0.5, borderColor: '#94a3b8', borderStyle: 'solid', objectFit: 'cover' };
    return styles.emergencyThumb;
  };

  const evaluableQuestions = allQuestions.filter((q) => !isPhotoOnlyQuestion(q));
  const totalActivities = evaluableQuestions.length;
  let countBueno = 0;
  let countRegular = 0;
  let countMalo = 0;
  let countNA = 0;
  let countPendientes = 0;

  evaluableQuestions.forEach((q) => {
    const ans = getAnswerForQuestion(q.id);
    if (!ans) {
      countPendientes++;
      return;
    }
    const st = getQuestionStatus(q, ans);
    if (st === 'B') countBueno++;
    else if (st === 'R') countRegular++;
    else if (st === 'M') countMalo++;
    else countNA++;
  });

  const aplicables = countBueno + countRegular + countMalo;
  const porcentajeCumplimiento = aplicables > 0
    ? ((countBueno / aplicables) * 100).toFixed(1).replace('.', ',') + '%'
    : '100,0%';

  let leftGroups = [];
  let rightGroups = [];
  if (groupsList.length === 1 && (groupsList[0].questions || []).length > 2) {
    const qList = groupsList[0].questions;
    const mid = Math.ceil(qList.length / 2);
    leftGroups = [{ ...groupsList[0], questions: qList.slice(0, mid) }];
    rightGroups = [{ ...groupsList[0], id: `${groupsList[0].id}_col2`, questions: qList.slice(mid) }];
  } else {
    let leftCount = 0;
    let rightCount = 0;
    groupsList.forEach((grp) => {
      const qCount = Math.max((grp.questions || []).length, 1);
      if (leftCount <= rightCount) {
        leftGroups.push(grp);
        leftCount += qCount + 1;
      } else {
        rightGroups.push(grp);
        rightCount += qCount + 1;
      }
    });
  }

  const getQuestionBaseHeight = (q) => {
    let h = 15; // Altura mínima base de fila de pregunta
    const ans = getAnswerForQuestion(q.id);
    const isPhotoOnly = isPhotoOnlyQuestion(q);
    const answerInfo = !isPhotoOnly ? getQuestionAnswerInfo(q, ans) : null;
    if (answerInfo?.customOptionText) {
      h += 9; // Espacio para texto de opción seleccionada personalizada
    }
    if (ans?.text && ans.text.trim()) {
      h += 11;
    }
    const photos = ans?.photos || [];
    if (photos.length > 0) {
      const count = photos.length;
      const thumbHeight = isPhotoOnly ? PHOTO_SIZES.full.h : PHOTO_SIZES.half.h;
      const rows = Math.ceil(count / 2);
      h += rows * (thumbHeight + 4) + 4;
    }
    return h;
  };

  // Lista de repuestos recomendados
  const allRawRecom = recommendations || data?.recommendations || [];
  const validRecom = Array.isArray(allRawRecom)
    ? allRawRecom.filter((rec) => {
        if (!rec) return false;
        const desc = (rec.description || '').trim();
        const obs = (rec.observation || '').trim();
        const prio = (rec.priority || '').trim();
        const qty = String(rec.quantity || '').trim();
        return desc !== '' || obs !== '' || prio !== '' || qty !== '';
      })
    : [];
  const hasRecommendations = validRecom.length > 0;

  // Lista de actividades asociadas al mantenimiento
  const allRawActivities = activities || data?.activities || [];
  const validActivities = Array.isArray(allRawActivities)
    ? allRawActivities.filter((a) => a && a.name && a.completed !== false)
    : [];
  const hasActivities = validActivities.length > 0;

  // Datos de encabezado y firmas
  const clientName =
    equipo?.customerName ||
    equipo?.customerData?.nombre ||
    equipo?.cliente?.nombre ||
    customerName ||
    'S/N';

  const clientAddress =
    equipo?.customerData?.direccion ||
    equipo?.cliente?.direccion ||
    equipo?.location ||
    equipo?.address ||
    'S/N';

  const clientEmail =
    customerEmail ||
    equipo?.customerEmail ||
    equipo?.customerData?.contacto_principal?.correo ||
    equipo?.customerData?.principalContact?.correo ||
    equipo?.customerData?.contactos?.find((c) => String(c.contactoPrincipal) === '1' || c.contactoPrincipal === true)?.correo ||
    equipo?.customerData?.contactos?.[0]?.correo ||
    equipo?.customerData?.correo ||
    equipo?.customerData?.email ||
    equipo?.cliente?.contacto_principal?.correo ||
    equipo?.cliente?.principalContact?.correo ||
    equipo?.email ||
    'S/N';

  const reportDate = new Date(data?.date || Date.now()).toLocaleDateString('es-CO');
  const formatTimeDisplay = (val) => {
    if (!val) return '—';
    const d = new Date(val);
    if (isNaN(d.getTime())) return '—';
    return d.toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' });
  };
  const startTimeDisplay = formatTimeDisplay(data?.start_time || data?.startTime || data?.date);
  const endTimeDisplay = formatTimeDisplay(data?.end_time || data?.endTime);

  const equipmentType = equipo?.elevatorTypeName || equipo?.nombre || 'S/N';
  const equipmentCapacity = equipo?.capacity ? `${equipo.capacity} Kg` : 'S/N';

  const obsText = data?.general_observations || data?.generalObservations || data?.observations || '';
  const partialObsText = data?.partial_close_observations || '';

  // 3 Firmas: 1. Quien ejecutó, 2. Quien entregó, 3. Quien recibe
  const techSigUrl = getFullUrl(data?.technicianSignature || data?.technician_signature);
  const deliverySigUrl = getFullUrl(
    data?.deliveryTechnicianSignature ||
      data?.delivery_technician_signature ||
      (data?.status === 'Finalizado' && !data?.delivery_technician_signature
        ? data?.technicianSignature || data?.technician_signature
        : null)
  );
  const custSigUrl = getFullUrl(data?.customerSignature || data?.customer_signature);

  const continuedName =
    continuedByTechnicianName || data?.continuedByTechnicianData?.name || '';
  const baseTechName = technicianName || data?.technicianData?.name || '';
  const techNameDisplay = continuedName
    ? `${baseTechName} / Cont: ${continuedName}`
    : baseTechName;

  const deliveryTechNameDisplay =
    deliveryTechnicianName ||
    data?.deliveryTechnicianData?.name ||
    (data?.status === 'Finalizado' ? baseTechName : 'Pendiente de entrega');

  const custNameDisplay =
    customerName ||
    data?.customer_name ||
    (data?.status === 'Pendiente de entrega' || data?.status === 'Parcial'
      ? 'Pendiente de entrega'
      : '');

  const reportId = data?.id || data?.maintenance_report_id || data?.maintenanceId || '';
  const cleanMaintenanceType = maintenanceType || data?.maintenance_type || data?.maintenanceType || '';
  const normType = cleanMaintenanceType.toLowerCase().trim();
  const isEmergencyOrCorrectivo = normType === 'emergencia' || normType === 'correctivo';

  const getEmergencyDetails = () => {
    let novedadText = '';
    let novedadPhotos = [];
    let procedText = '';
    let procedPhotos = [];
    let subsanada = 'SI';

    const answersObj = data?.answers || {};
    const answersList = Array.isArray(answersObj)
      ? answersObj
      : Object.values(answersObj);

    for (const ans of answersList) {
      if (!ans) continue;
      const qId = Number(ans.question_id || ans.id);
      const text = (ans.text || ans.answer_text || '').trim();
      const photos = ans.photos || [];
      const opts = (ans.optionIds || ans.selected_options || []).map(String);

      if (qId === 9001 || (ans.question_name && ans.question_name.toLowerCase().includes('novedad'))) {
        if (!novedadText) novedadText = text;
        if (photos.length > 0 && novedadPhotos.length === 0) novedadPhotos = photos;
      } else if (qId === 9002 || (ans.question_name && ans.question_name.toLowerCase().includes('procedimiento'))) {
        if (!procedText) procedText = text;
        if (photos.length > 0 && procedPhotos.length === 0) procedPhotos = photos;
      } else if (qId === 9003 || (ans.question_name && ans.question_name.toLowerCase().includes('subsanada'))) {
        if (opts.some((o) => o.toUpperCase() === 'NO') || text.toUpperCase() === 'NO') {
          subsanada = 'NO';
        } else if (opts.some((o) => o.toUpperCase() === 'SI') || text.toUpperCase() === 'SI') {
          subsanada = 'SI';
        }
      }
    }

    if (!novedadText && answersObj[9001]?.text) novedadText = answersObj[9001].text;
    if (!novedadPhotos.length && answersObj[9001]?.photos) novedadPhotos = answersObj[9001].photos;

    if (!procedText && answersObj[9002]?.text) procedText = answersObj[9002].text;
    if (!procedPhotos.length && answersObj[9002]?.photos) procedPhotos = answersObj[9002].photos;

    if (answersObj[9003]) {
      const opt = answersObj[9003].optionIds?.[0] || answersObj[9003].selected_options?.[0] || answersObj[9003].text;
      if (opt && String(opt).toUpperCase() === 'NO') subsanada = 'NO';
      else if (opt && String(opt).toUpperCase() === 'SI') subsanada = 'SI';
    }

    if ((!novedadText || !procedText) && (data?.general_observations || data?.generalObservations)) {
      const obs = data?.general_observations || data?.generalObservations || '';
      const mNov = obs.match(/Novedad:\s*(.*?)(?=\s*\|\s*Procedimiento:|$)/i);
      const mProc = obs.match(/Procedimiento:\s*(.*?)(?=\s*\|\s*Subsanada:|$)/i);
      const mSub = obs.match(/Subsanada:\s*(.*?)(?=\s*\|$|$)/i);
      if (!novedadText && mNov) novedadText = mNov[1].trim();
      if (!procedText && mProc) procedText = mProc[1].trim();
      if (mSub) subsanada = mSub[1].trim().toUpperCase() === 'NO' ? 'NO' : 'SI';
      if (!novedadText && !mNov) novedadText = obs;
    }

    return { novedadText, novedadPhotos, procedText, procedPhotos, subsanada };
  };

  const emergDetails = isEmergencyOrCorrectivo ? getEmergencyDetails() : null;

  // Renderizador reutilizable de la tabla de 3 firmas (Quien ejecutó, Quien entregó, Quien recibe)
  const renderThreeSignaturesTable = () => (
    <View style={styles.signaturesTable}>
      {/* Columna 1: Quien Ejecutó (Técnico) */}
      <View style={styles.signatureCol3}>
        <Text style={styles.sigHeaderCell}>Quien Ejecutó (Empresa)</Text>
        <View style={styles.sigImgBox}>
          {techSigUrl ? (
            <Image style={styles.sigImg} src={techSigUrl} />
          ) : (
            <Text style={styles.pendingDeliveryBadge}>Sin firma</Text>
          )}
        </View>
        <View style={styles.sigMetaCell}>
          <Text><Text style={styles.bold}>Nombre: </Text>{techNameDisplay || '—'}</Text>
        </View>
        <View style={[styles.sigMetaCell, { borderBottomWidth: 0 }]}>
          <Text><Text style={styles.bold}>Cargo: </Text>Técnico de Mantenimiento</Text>
        </View>
      </View>

      {/* Columna 2: Quien Entregó (Técnico / Empresa) */}
      <View style={styles.signatureCol3}>
        <Text style={styles.sigHeaderCell}>Quien Entregó (Empresa)</Text>
        <View style={styles.sigImgBox}>
          {deliverySigUrl ? (
            <Image style={styles.sigImg} src={deliverySigUrl} />
          ) : (
            <Text style={styles.pendingDeliveryBadge}>Pendiente de entrega</Text>
          )}
        </View>
        <View style={styles.sigMetaCell}>
          <Text><Text style={styles.bold}>Nombre: </Text>{deliveryTechNameDisplay || 'Pendiente'}</Text>
        </View>
        <View style={[styles.sigMetaCell, { borderBottomWidth: 0 }]}>
          <Text><Text style={styles.bold}>Cargo: </Text>Técnico / Entrega DIMEI</Text>
        </View>
      </View>

      {/* Columna 3: Quien Recibe (Cliente) */}
      <View style={[styles.signatureCol3, { borderRightWidth: 0 }]}>
        <Text style={styles.sigHeaderCell}>Quien Recibe (Cliente)</Text>
        <View style={styles.sigImgBox}>
          {custSigUrl ? (
            <Image style={styles.sigImg} src={custSigUrl} />
          ) : (
            <Text style={styles.pendingDeliveryBadge}>Pendiente de entrega</Text>
          )}
        </View>
        <View style={styles.sigMetaCell}>
          <Text><Text style={styles.bold}>Nombre: </Text>{custNameDisplay || 'Pendiente'}</Text>
        </View>
        <View style={[styles.sigMetaCell, { borderBottomWidth: 0 }]}>
          <Text><Text style={styles.bold}>Cargo: </Text>Cliente / Encargado</Text>
        </View>
      </View>
    </View>
  );

  // Renderizador de Actividades Asociadas
  const renderActivitiesBox = () => {
    if (!hasActivities) return null;
    return (
      <View style={styles.recomBox} wrap={false}>
        <View style={styles.recomHeaderBar}>
          <Text style={styles.recomHeaderTitle}>ACCIONES / ACTIVIDADES PREVIAS AL MANTENIMIENTO</Text>
        </View>
        <View style={styles.recomRowHeader}>
          <Text style={styles.recomColNum}>Nº</Text>
          <Text style={[styles.recomColDesc, { width: '54%' }]}>Acción / Actividad Previa</Text>
          <Text style={[styles.recomColObs, { width: '40%' }]}>Observación / Detalle</Text>
        </View>
        {validActivities.map((act, idx) => {
          const isLast = idx === validActivities.length - 1;
          return (
            <View key={idx} style={[styles.recomRow, isLast ? { borderBottomWidth: 0 } : {}]}>
              <Text style={styles.recomColNum}>{idx + 1}</Text>
              <Text style={[styles.recomColDesc, { width: '54%' }]}>{act.name || ''}</Text>
              <Text style={[styles.recomColObs, { width: '40%' }]}>{act.observation || 'Ejecutada'}</Text>
            </View>
          );
        })}
      </View>
    );
  };

  // Renderizador de un grupo de preguntas
  const renderGroupBlock = (grp, extraPerQ = 0, isLastInCol = false) => {
    const questions = grp.questions || [];
    const grpIsAllPhotoOnly = questions.length > 0 && questions.every(isPhotoOnlyQuestion);

    return (
      <View
        key={grp.id || grp.name}
        style={[styles.groupBlock, isLastInCol ? { flexGrow: 1 } : {}]}
        wrap={false}
      >
        <View style={styles.groupHeaderRow}>
          <Text style={[styles.groupTitleText, grpIsAllPhotoOnly ? { width: '100%' } : {}]}>
            {grp.name}
          </Text>
          {!grpIsAllPhotoOnly && (
            <Text style={styles.groupResponseHead}>Respuesta</Text>
          )}
        </View>

        {questions.map((q, qIdx) => {
          const ans = getAnswerForQuestion(q.id);
          const isPhotoOnly = isPhotoOnlyQuestion(q);
          const answerInfo = !isPhotoOnly ? getQuestionAnswerInfo(q, ans) : null;
          const isLastQ = qIdx === questions.length - 1;
          const photos = ans?.photos || [];
          const rowMinHeight = getQuestionBaseHeight(q) + extraPerQ;

          const questionWithOptions = (q?.options && q.options.length > 0)
            ? q
            : ((group?.questions || allQuestions || []).find((item) => String(item.id) === String(q?.id)) || q);
          const qOptions = questionWithOptions?.options || questionWithOptions?.AnswerOptions || questionWithOptions?.answer_options || [];
          const rawSelected = ans?.optionIds || ans?.selected_options || [];
          const selList = Array.isArray(rawSelected) ? rawSelected : [rawSelected].filter(Boolean);
          const selIds = selList.map(String);

          // Observación solo si la pide por pregunta (pregunta abierta o si la opción seleccionada requiere justificación)
          const requiresObs = q.type === 'abierta' || qOptions.some((o) =>
            selIds.includes(String(o.id)) &&
            (o.requires_justification === 1 || o.requires_justification === true || o.requires_justification === '1')
          );

          return (
            <View
              key={q.id}
              style={[
                styles.questionRow,
                { minHeight: rowMinHeight, flexGrow: 1 },
                isLastQ ? { borderBottomWidth: 0 } : {},
              ]}
            >
              <View style={[styles.qTextCol, isPhotoOnly ? { width: '100%', borderRightWidth: 0 } : {}]}>
                <Text style={styles.qTitle}>{q.text}</Text>

                {/* Opción seleccionada entre comillas si es diferente a buena/regular/mala */}
                {answerInfo?.customOptionText ? (
                  <Text style={styles.qCustomOptionText}>{`"${answerInfo.customOptionText}"`}</Text>
                ) : null}

                {/* Observación debajo de la pregunta solo si la pide por pregunta */}
                {requiresObs && ans?.text ? (
                  <Text style={styles.qObsText}>Obs: {ans.text}</Text>
                ) : null}

                {photos.length > 0 ? (
                  <View style={styles.qPhotosContainer}>
                    {photos.map((p, pIdx) => {
                      const imgUrl = getFullUrl(p);
                      const linkUrl = getPhotoLinkUrl(p) || imgUrl;
                      if (!imgUrl) return null;
                      const thumbStyle = getPhotoThumbStyle(photos.length, isPhotoOnly);
                      const cellStyle = { width: '48%', marginRight: pIdx % 2 === 0 ? '4%' : 0, marginBottom: 4 };
                      return (
                        <View key={pIdx} style={cellStyle}>
                          {linkUrl ? (
                            <Link src={linkUrl} style={{ textDecoration: 'none' }}>
                              <Image style={thumbStyle} src={imgUrl} />
                            </Link>
                          ) : (
                            <Image style={thumbStyle} src={imgUrl} />
                          )}
                        </View>
                      );
                    })}
                  </View>
                ) : null}
              </View>

              {!isPhotoOnly && answerInfo && (
                <View style={[styles.qResponseCol, { backgroundColor: answerInfo.bg }]}>
                  <Text style={[
                    styles.responseText,
                    {
                      color: answerInfo.status === 'B' ? '#047857'
                        : answerInfo.status === 'R' ? '#b45309'
                        : answerInfo.status === 'M' ? '#b91c1c'
                        : '#475569'
                    }
                  ]}>
                    {answerInfo.label}
                  </Text>
                </View>
              )}
            </View>
          );
        })}
      </View>
    );
  };

  return (
    <Document title={`${reportId || 'Mantenimiento'}-${clientName}-${equipmentType}-${cleanMaintenanceType || 'Preventivo'}`}>
      <Page size="LETTER" style={styles.page}>
        {/* ================= 1. ENCABEZADO SUPERIOR ================= */}
        <View style={styles.topHeaderTable}>
          <View style={styles.headerLogoCol}>
            <Image style={styles.headerLogo} src="/img/logo_reporte.png" />
          </View>

          <View style={styles.headerCenterCol}>
            <Text style={styles.companyName}>EQUIPOS DIMEI SAS NIT 901.230.958-5</Text>
            <Text style={styles.companyContact}>
              Contacto servicio al cliente: mantenimiento@equiposdimei.com Tel: 3046164709
            </Text>
            <Link style={styles.companyWebsite} src="https://www.equiposdimei.com">
              www.equiposdimei.com
            </Link>
          </View>

          <View style={styles.headerRightCol}>
            <View style={styles.metaItemRow}>
              <Text style={styles.metaRowText}>
                <Text style={styles.bold}>Código: </Text>ED-290422a
              </Text>
            </View>
            <View style={styles.metaItemRow}>
              <Text style={styles.metaRowText}>
                <Text style={styles.bold}>Versión: </Text>003
              </Text>
            </View>
            <View style={[styles.metaItemRow, { borderBottomWidth: 0 }]}>
              <Text style={styles.metaRowText}>
                <Text style={styles.bold}>Fecha: </Text>29/04/2022
              </Text>
            </View>
          </View>
        </View>

        {/* ================= 2. METADATOS DEL REPORTE ================= */}
        <View style={styles.metaTable}>
          <View style={styles.metaTitleBar}>
            <Text style={styles.metaTitleText}>
              {`REPORTE DE MANTENIMIENTO${reportId ? ` N° ${reportId}` : ''}${cleanMaintenanceType ? ` - ${cleanMaintenanceType.toUpperCase()}` : ''}${data?.status && data.status !== 'Finalizado' ? ` (${data.status.toUpperCase()})` : ''}`}
            </Text>
          </View>

          {/* Fila 1: Cliente & Correo */}
          <View style={styles.metaRow}>
            <View style={[styles.metaCell, { width: '50%', borderRightWidth: 1, borderColor: '#000000', borderStyle: 'solid' }]}>
              <Text><Text style={styles.bold}>Cliente: </Text>{clientName}</Text>
            </View>
            <View style={[styles.metaCell, { width: '50%' }]}>
              <Text><Text style={styles.bold}>Correo: </Text>{clientEmail}</Text>
            </View>
          </View>

          {/* Fila 2: Dirección & Fecha */}
          <View style={styles.metaRow}>
            <View style={[styles.metaCell, { width: '50%', borderRightWidth: 1, borderColor: '#000000', borderStyle: 'solid' }]}>
              <Text><Text style={styles.bold}>Dirección: </Text>{clientAddress}</Text>
            </View>
            <View style={[styles.metaCell, { width: '50%' }]}>
              <Text><Text style={styles.bold}>Fecha: </Text>{reportDate}</Text>
            </View>
          </View>

          {/* Fila 3: Tipo de equipo & Capacidad */}
          <View style={styles.metaRow}>
            <View style={[styles.metaCell, { width: '50%', borderRightWidth: 1, borderColor: '#000000', borderStyle: 'solid' }]}>
              <Text><Text style={styles.bold}>Tipo de equipo: </Text>{equipmentType}</Text>
            </View>
            <View style={[styles.metaCell, { width: '50%' }]}>
              <Text><Text style={styles.bold}>Capacidad: </Text>{equipmentCapacity}</Text>
            </View>
          </View>

          {/* Fila 4: Hora Inicio & Hora Final */}
          <View style={[styles.metaRow, { borderBottomWidth: 0 }]}>
            <View style={[styles.metaCell, { width: '50%', borderRightWidth: 1, borderColor: '#000000', borderStyle: 'solid' }]}>
              <Text><Text style={styles.bold}>Hora Inicio: </Text>{startTimeDisplay}</Text>
            </View>
            <View style={[styles.metaCell, { width: '50%' }]}>
              <Text><Text style={styles.bold}>Hora Final: </Text>{endTimeDisplay}</Text>
            </View>
          </View>
        </View>

        {isEmergencyOrCorrectivo ? (
          /* ================= FORMATO DE EMERGENCIA Y CORRECTIVO ================= */
          <View style={styles.emergencyContainer} wrap={false}>
            {/* 1. Descripción de novedad: */}
            <View style={styles.emergencyBoxSection}>
              <Text style={styles.emergencySectionTitle}>Descripción de novedad:</Text>
              {emergDetails?.novedadText ? (
                <Text style={styles.emergencyContentText}>{emergDetails.novedadText}</Text>
              ) : null}

              {emergDetails?.novedadPhotos?.length > 0 ? (
                <View style={styles.emergencyPhotosRow}>
                  {emergDetails.novedadPhotos.map((p, pIdx) => {
                    const imgUrl = getFullUrl(p);
                    const linkUrl = getPhotoLinkUrl(p) || imgUrl;
                    if (!imgUrl) return null;
                    const thumbStyle = getEmergencyThumbStyle(emergDetails.novedadPhotos.length);
                    return linkUrl ? (
                      <Link key={pIdx} src={linkUrl} style={styles.emergencyThumbLink}>
                        <Image style={thumbStyle} src={imgUrl} />
                      </Link>
                    ) : (
                      <Image key={pIdx} style={thumbStyle} src={imgUrl} />
                    );
                  })}
                </View>
              ) : null}
            </View>

            {/* 2. Procedimiento realizado: */}
            <View style={styles.emergencyBoxSection}>
              <Text style={styles.emergencySectionTitle}>Procedimiento realizado:</Text>
              {emergDetails?.procedText ? (
                <Text style={styles.emergencyContentText}>{emergDetails.procedText}</Text>
              ) : null}

              {emergDetails?.procedPhotos?.length > 0 ? (
                <View style={styles.emergencyPhotosRow}>
                  {emergDetails.procedPhotos.map((p, pIdx) => {
                    const imgUrl = getFullUrl(p);
                    const linkUrl = getPhotoLinkUrl(p) || imgUrl;
                    if (!imgUrl) return null;
                    const thumbStyle = getEmergencyThumbStyle(emergDetails.procedPhotos.length);
                    return linkUrl ? (
                      <Link key={pIdx} src={linkUrl} style={styles.emergencyThumbLink}>
                        <Image style={thumbStyle} src={imgUrl} />
                      </Link>
                    ) : (
                      <Image key={pIdx} style={thumbStyle} src={imgUrl} />
                    );
                  })}
                </View>
              ) : null}
            </View>

            {/* 3. La falla fue Subsanada | SI | NO */}
            <View style={styles.emergencySubsanadaRow}>
              <View style={styles.emergencySubsanadaLabelCell}>
                <Text style={styles.emergencySubsanadaLabelText}>La falla fue Subsanada</Text>
              </View>

              <View style={styles.emergencySubsanadaOptionCell}>
                <Text style={styles.emergencyOptionText}>SI</Text>
                <View style={styles.emergencyCheckSquare}>
                  <Text style={styles.emergencyCheckText}>
                    {emergDetails?.subsanada === 'SI' ? 'X' : ''}
                  </Text>
                </View>
              </View>

              <View style={[styles.emergencySubsanadaOptionCell, { borderRightWidth: 0 }]}>
                <Text style={styles.emergencyOptionText}>NO</Text>
                <View style={styles.emergencyCheckSquare}>
                  <Text style={styles.emergencyCheckText}>
                    {emergDetails?.subsanada === 'NO' ? 'X' : ''}
                  </Text>
                </View>
              </View>
            </View>

            {/* Actividades Asociadas */}
            {hasActivities ? (
              <View style={{ paddingHorizontal: 4, paddingTop: 4 }}>
                {renderActivitiesBox()}
              </View>
            ) : null}

            {/* Repuestos / Trabajos Recomendados */}
            {hasRecommendations ? (
              <View style={[styles.recomBox, { margin: 4 }]} wrap={false}>
                <View style={styles.recomHeaderBar}>
                  <Text style={styles.recomHeaderTitle}>REPUESTOS / TRABAJOS RECOMENDADOS</Text>
                </View>
                <View style={styles.recomRowHeader}>
                  <Text style={styles.recomColNum}>Nº</Text>
                  <Text style={styles.recomColDesc}>Descripción del repuesto o trabajo</Text>
                  <Text style={styles.recomColQty}>Cant.</Text>
                  <Text style={styles.recomColPrio}>Prioridad</Text>
                  <Text style={styles.recomColObs}>Observación</Text>
                </View>
                {validRecom.map((rec, rIdx) => {
                  const isLast = rIdx === validRecom.length - 1;
                  return (
                    <View key={rIdx} style={[styles.recomRow, isLast ? { borderBottomWidth: 0 } : {}]}>
                      <Text style={styles.recomColNum}>{rIdx + 1}</Text>
                      <Text style={styles.recomColDesc}>{rec.description || ''}</Text>
                      <Text style={styles.recomColQty}>{rec.quantity || ''}</Text>
                      <Text style={styles.recomColPrio}>{rec.priority || ''}</Text>
                      <Text style={styles.recomColObs}>{rec.observation || ''}</Text>
                    </View>
                  );
                })}
              </View>
            ) : null}

            {/* 4. Tabla de 3 Firmas (Ejecutó / Entregó / Recibe) */}
            {renderThreeSignaturesTable()}
          </View>
        ) : (
          /* ================= FORMATO ESTÁNDAR (PREVENTIVO) ================= */
          <>
            {/* 3. PREGUNTAS EN 2 COLUMNAS */}
            <View style={styles.twoColWrapper}>
              <View style={styles.colHalf}>
                {leftGroups.map((grp, i) => renderGroupBlock(grp, 0, i === leftGroups.length - 1))}
              </View>
              <View style={styles.colHalf}>
                {rightGroups.map((grp, i) => renderGroupBlock(grp, 0, i === rightGroups.length - 1))}
              </View>
            </View>

            {/* 4. RESUMEN DE LA INSPECCIÓN */}
            <View style={styles.summaryBox} wrap={false}>
              <View style={styles.summaryHeaderBar}>
                <Text style={styles.summaryHeaderTitle}>RESUMEN DE LA INSPECCIÓN</Text>
              </View>
              <View style={styles.summaryRow}>
                <Text style={styles.summaryLabel}>Total de actividades</Text>
                <Text style={styles.summaryVal}>{totalActivities}</Text>
              </View>
              <View style={styles.summaryRow}>
                <Text style={styles.summaryLabel}>Actividades en BUENO</Text>
                <Text style={styles.summaryVal}>{countBueno}</Text>
              </View>
              <View style={styles.summaryRow}>
                <Text style={styles.summaryLabel}>Actividades en REGULAR</Text>
                <Text style={styles.summaryVal}>{countRegular}</Text>
              </View>
              <View style={styles.summaryRow}>
                <Text style={styles.summaryLabel}>Actividades en MALO</Text>
                <Text style={styles.summaryVal}>{countMalo}</Text>
              </View>
              <View style={styles.summaryRow}>
                <Text style={styles.summaryLabel}>No aplica (N/A)</Text>
                <Text style={styles.summaryVal}>{countNA}</Text>
              </View>
              <View style={styles.summaryRow}>
                <Text style={styles.summaryLabel}>Pendientes por revisar</Text>
                <Text style={styles.summaryVal}>{countPendientes}</Text>
              </View>
              <View style={[styles.summaryRow, { borderBottomWidth: 0 }]}>
                <Text style={styles.summaryLabel}>% de cumplimiento (BIEN / aplicables)</Text>
                <Text style={styles.summaryVal}>{porcentajeCumplimiento}</Text>
              </View>
            </View>

            {/* 5. ACTIVIDADES ASOCIADAS */}
            {renderActivitiesBox()}

            {/* 6. REPUESTOS / TRABAJOS RECOMENDADOS */}
            {hasRecommendations ? (
              <View style={styles.recomBox} wrap={false}>
                <View style={styles.recomHeaderBar}>
                  <Text style={styles.recomHeaderTitle}>REPUESTOS / TRABAJOS RECOMENDADOS</Text>
                </View>
                <View style={styles.recomRowHeader}>
                  <Text style={styles.recomColNum}>Nº</Text>
                  <Text style={styles.recomColDesc}>Descripción del repuesto o trabajo</Text>
                  <Text style={styles.recomColQty}>Cant.</Text>
                  <Text style={styles.recomColPrio}>Prioridad</Text>
                  <Text style={styles.recomColObs}>Observación</Text>
                </View>
                {validRecom.map((rec, rIdx) => {
                  const isLast = rIdx === validRecom.length - 1;
                  return (
                    <View key={rIdx} style={[styles.recomRow, isLast ? { borderBottomWidth: 0 } : {}]}>
                      <Text style={styles.recomColNum}>{rIdx + 1}</Text>
                      <Text style={styles.recomColDesc}>{rec.description || ''}</Text>
                      <Text style={styles.recomColQty}>{rec.quantity || ''}</Text>
                      <Text style={styles.recomColPrio}>{rec.priority || ''}</Text>
                      <Text style={styles.recomColObs}>{rec.observation || ''}</Text>
                    </View>
                  );
                })}
              </View>
            ) : null}

            {/* 7. OBSERVACIONES, LEYENDA Y 3 FIRMAS */}
            <View style={styles.obsSection} wrap={false}>
              <View style={styles.obsHeaderBar}>
                <Text style={styles.obsHeaderTitle}>Observaciones</Text>
              </View>
              <View style={styles.obsBody}>
                <Text style={styles.obsBodyText}>
                  {[obsText, partialObsText ? `Cierre parcial: ${partialObsText}` : '']
                    .filter(Boolean)
                    .join(' | ') || 'Sin observaciones adicionales registradas.'}
                </Text>
              </View>

              <View style={styles.legendBar}>
                <Text style={styles.legendText}>B: Bueno  R: Regular  M: Malo  NA: No aplica</Text>
              </View>

              {/* Tabla de 3 Firmas (Ejecutó / Entregó / Recibe) */}
              {renderThreeSignaturesTable()}
            </View>
          </>
        )}
      </Page>
    </Document>
  );
}
